export async function responder (e) {
  try {
    if (!e.data) return
    
    const payload = JSON.parse(e.data)
    
    if (!payload.func) return
    
    const result = await e.target[payload.func](...payload.args || [])

    parent.postMessage(JSON.stringify({
      result,
      msgID: payload.msgID
    }), '*')
  }
  catch (_e) {
    //
  }
}